module.exports = __webpack_public_path__ + "img/guanziqian-2.prt.6eff84a7.jpg";